import Webcam from "react-webcam";
import { getDataFromStorage } from "../../../util";
import React, { useContext, useEffect, useState } from "react";
import ProctorEyeSvg from "../../../Svg/ProctorEyeSvg";
import AlertContext from "../../../context/AlertContext";
import MobileViewSetUpHooks from "../../../Hooks/InstructionPage/MobileViewSetUpHooks";

export default function MobileViewSetUp() {
  const Alert = useContext(AlertContext);

  const MobileViewSetUpHks = MobileViewSetUpHooks();

  const status = parseInt(getDataFromStorage("status"));
  
  const [firstCaptureDone, setFirstCaptureDone] = useState(false);

  useEffect(() => {
    if (status === 3) {
      return (window.location.href = "https://gradious.com/");
    }

    // Immediate first capture when status is 1 (setup phase)
    if (status === 1 && !firstCaptureDone) {
      console.log("Attempting initial image capture...");
      MobileViewSetUpHks.captureAndUploadImage()
        .then(() => {
          console.log("Initial capture successful");
          setFirstCaptureDone(true);
          Alert.setShowNotify({
            show: true,
            title: "Image Captured",
            msg: "Setup image captured successfully. You may now verify on your laptop.",
          });
        })
        .catch((error) => {
          console.error("Initial capture failed:", error);
        });
    }

    // Continue periodic captures
    const interval = setInterval(
      () => {
        MobileViewSetUpHks.captureAndUploadImage();
      },
      status === 2 ? 30000 : 5000
    );

    return () => clearInterval(interval);
  }, [status, firstCaptureDone]);

  useEffect(() => {
    const interval = setInterval(() => {
      MobileViewSetUpHks.validateToken();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const handleWebCamError = (err) => {
    Alert.setShowNotify({
      show: true,
      title: "Camera Permission Required",
      msg: "Camera access is required. Please enable it in your browser.",
    });
  };

  return (
    <div className="dpBody">
      <div className="dpBodyUpper">
        <div className="dpBodyHeader">
          <ProctorEyeSvg type={2} />
          <div className="dpBodyHeaderLabel">Mobile Camera View</div>
        </div>
        <div className="dpBodyMain">
          Follow the steps below to finalize setup:
          <ul className="dpBodyMainUl">
            <li>
              Place your phone where it clearly captures your test environment.
            </li>
            <li>Use landscape orientation and switch to full screen mode.</li>
            <li> Keep this screen open throughout the test.</li>
          </ul>
          <span className="dpBodyWarning">
            Do not close or minimize this screen.
          </span>
        </div>
        <div className="dpCamera">
          <Webcam
            audio={false}
            playsInline
            mirrored={true}
            className="dpWebCam"
            screenshotFormat="image/jpeg"
            ref={MobileViewSetUpHks.picRef}
            onUserMediaError={handleWebCamError}
            videoConstraints={MobileViewSetUpHks.videoConstraints}
          />
        </div>
      </div>
    </div>
  );
}
